
import { Vue, Options } from "vue-class-component";
import { VideoConfig } from "../video/VideoConfig";
@Options({
  props: {
    width: String,
    height: String
  }
})
export default class Video extends Vue {
  $refs!: {
    div: HTMLDivElement;
    video: HTMLVideoElement;
    canvas: HTMLCanvasElement;
    progress: HTMLProgressElement;
  };
  // 是否显示视频
  private isShowVideo = true;
  // 是否显示Controls
  private isShowControls = false;
  // 是否显示播放页面
  private isShowPlay = true;
  private timerInterval: number | null = 0;
  private automaticTimer: number | null = 0;
  private videoDuration = 0;
  mounted() {
    this.setIntervalReloadData();
    this.creatVideo();
  }
  creatVideo() {
    this.isShowVideo = !this.noLive();
    if (this.isShowVideo) {
      this.$refs.video.addEventListener("ended", () => {
        this.isShowControls = true;
      });
    }
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const self = this;
    this.timerInterval = setInterval(() => {
      if (self.timerInterval != null) {
        clearTimeout(self.timerInterval);
      }
      self.videoStatus();
    }, 500);
  }
  // 自动播放
  play() {
    this.playEvent();
    document.addEventListener(
      "WeixinJSBridgeReady",
      function() {
        const vid = document.getElementById("video") as HTMLVideoElement;
        vid.play();
      },
      false
    );
  }

  // 距离直播3分钟就倒计时
  setIntervalReloadData() {
    const now = new Date();
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const self = this;
    const seconds = VideoConfig.statusTimer - now.getTime();
    if (seconds < 180000 && seconds > 0) {
      self.timerInterval = setInterval(() => {
        if (self.timerInterval != null) {
          clearTimeout(self.timerInterval);
        }
        self.playEvent();
      }, seconds + 3000);
    }
  }

  isShowPlayEvent() {
    this.playEvent();
  }
  playEvent() {
    this.isShowPlay = !this.isShowPlay;
    if (!this.isShowPlay) {
      this.videoStatus();
      this.$refs.video.play();
    } else {
      this.$refs.video.pause();
    }
  }
  videoStatus() {
    /// 播中
    if (this.liveStreaming()) {
      this.isShowControls = false;
      const vid = document.getElementById("video") as HTMLVideoElement;
      vid.currentTime = this.currentTime();
    }
    // 播完
    else if (this.liveBroadcast()) {
      this.isShowControls = true;
    }
  }
  pauseEvent() {
    this.$refs.video.pause();
  }
  /// 未播
  noLive(): boolean {
    const now = new Date();
    const nowTimer = now.getTime();
    if (nowTimer < VideoConfig.statusTimer) {
      return true;
    }
    return false;
  }
  /// 播中
  liveStreaming(): boolean {
    const now = new Date();
    const nowTimer = now.getTime();
    // 直播总时间 = 总时长 + (视频时间*每分钟的时间戳)
    // const liveTotalTimer =
    //   VideoConfig.statusTimer +
    //   this.$refs.video.duration * VideoConfig.minutesTimestamp;
    const liveTotalTimer = VideoConfig.liveendTimer;
    // 当前时间大于开始时间 && 当前时间小于直播时间
    if (nowTimer > VideoConfig.statusTimer && nowTimer < liveTotalTimer) {
      return true;
    }
    return false;
  }
  /// 播完
  liveBroadcast(): boolean {
    const now = new Date();
    const nowTimer = now.getTime();
    // 直播总时间 = 总时长 + (视频时间*每分钟的时间戳)
    // let liveTotalTimer =
    //   VideoConfig.statusTimer +
    //   this.$refs.video.duration * VideoConfig.minutesTimestamp;
    const liveTotalTimer = VideoConfig.endTimer;
    // 当前时间大于直播时间
    if (nowTimer > liveTotalTimer) {
      return true;
    }
    return false;
  }
  // 播放时长
  currentTime(): number {
    // const videoDuration = this.$refs.video.duration;
    const videoDuration = 4811.4;
    const now = new Date().getTime();
    // 总时间
    const liveTotalTimer =
      VideoConfig.statusTimer + videoDuration * VideoConfig.minutesTimestamp;
    // 剩余时间
    const lastTimer = (liveTotalTimer - now) / VideoConfig.minutesTimestamp;
    const currentTime = videoDuration - lastTimer;
    return currentTime;
  }
}
